module.exports = __webpack_public_path__ + "static/media/offers.ba9c7955.svg";